(() => {
  function initAnnouncementRotators() {
    document.querySelectorAll("[data-tb-announcements]").forEach((root) => {
      const items = Array.from(root.querySelectorAll("[data-tb-announcement-item]"));
      if (items.length < 2 || root.dataset.tbReady === "true") {
        return;
      }

      root.dataset.tbReady = "true";
      let index = 0;
      window.setInterval(() => {
        items[index].classList.remove("is-active");
        index = (index + 1) % items.length;
        items[index].classList.add("is-active");
      }, 3200);
    });
  }

  function initDrawers() {
    document.querySelectorAll("[data-tb-header]").forEach((header) => {
      if (header.dataset.tbDrawerReady === "true") {
        return;
      }

      header.dataset.tbDrawerReady = "true";
      const drawer = header.querySelector("[data-tb-drawer]");
      const openers = header.querySelectorAll("[data-tb-drawer-open]");
      const closers = header.querySelectorAll("[data-tb-drawer-close]");
      if (!drawer) {
        return;
      }

      const openDrawer = () => {
        drawer.classList.add("is-open");
        document.documentElement.style.overflow = "hidden";
      };

      const closeDrawer = () => {
        drawer.classList.remove("is-open");
        document.documentElement.style.overflow = "";
      };

      openers.forEach((button) => button.addEventListener("click", openDrawer));
      closers.forEach((button) => button.addEventListener("click", closeDrawer));
      drawer.addEventListener("click", (event) => {
        if (event.target === drawer) {
          closeDrawer();
        }
      });
    });
  }

  function initCarousel(root) {
    if (!root || root.dataset.tbCarouselReady === "true") {
      return;
    }

    const track = root.querySelector("[data-tb-carousel-track]");
    const slides = Array.from(root.querySelectorAll("[data-tb-carousel-slide]"));
    if (!track || slides.length === 0) {
      return;
    }

    root.dataset.tbCarouselReady = "true";
    const dots = Array.from(root.querySelectorAll("[data-tb-carousel-dot]"));
    const prev = root.querySelector("[data-tb-carousel-prev]");
    const next = root.querySelector("[data-tb-carousel-next]");
    const interval = Number(root.dataset.tbAutoplay || 0);
    let index = 0;
    let timer = null;

    function paint() {
      track.style.transform = `translateX(${index * -100}%)`;
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle("is-active", dotIndex === index);
        dot.setAttribute("aria-current", dotIndex === index ? "true" : "false");
      });
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      paint();
    }

    function resume() {
      if (!interval || slides.length < 2) {
        return;
      }
      window.clearInterval(timer);
      timer = window.setInterval(() => goTo(index + 1), interval);
    }

    prev?.addEventListener("click", () => {
      goTo(index - 1);
      resume();
    });

    next?.addEventListener("click", () => {
      goTo(index + 1);
      resume();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener("click", () => {
        goTo(dotIndex);
        resume();
      });
    });

    root.addEventListener("mouseenter", () => window.clearInterval(timer));
    root.addEventListener("mouseleave", resume);
    root.addEventListener("focusin", () => window.clearInterval(timer));
    root.addEventListener("focusout", resume);

    paint();
    resume();
  }

  function initCarousels() {
    document.querySelectorAll("[data-tb-carousel]").forEach(initCarousel);
  }

  function scrubMorePaymentOptions(root = document) {
    if (!root || typeof root.querySelectorAll !== "function") {
      return;
    }

    root
      .querySelectorAll("more-payment-options-link, .shopify-payment-button__more-options")
      .forEach((node) => {
        node.remove();
      });
  }

  function initMorePaymentOptionsScrubber() {
    if (!document.documentElement || document.documentElement.dataset.tbPaymentOptionsScrubber === "true") {
      return;
    }

    document.documentElement.dataset.tbPaymentOptionsScrubber = "true";
    scrubMorePaymentOptions();

    const observer = new MutationObserver(() => {
      scrubMorePaymentOptions();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    window.addEventListener("load", () => {
      scrubMorePaymentOptions();
    });
  }

  function normalizeLegacyFooterMenus(root = document) {
    if (!root || typeof root.querySelector !== "function") {
      return;
    }

    const footer = root.querySelector(".tb-footer");
    if (!footer || footer.dataset.tbFooterNormalized === "true") {
      return;
    }

    const menus = Array.from(footer.querySelectorAll(".tb-footer__menu"));
    if (menus.length < 2) {
      return;
    }

    const linkLookup = new Map();
    footer.querySelectorAll(".tb-footer__menu a[href]").forEach((link) => {
      const text = (link.textContent || "").trim();
      const href = link.getAttribute("href");
      if (text && href && !linkLookup.has(text)) {
        linkLookup.set(text, href);
      }
    });

    const desiredLinks = [
      ["Shop Products", linkLookup.get("Shop All") || "/collections/all-oral-health-products"],
      ["Contact Us", linkLookup.get("Contact Us") || "/pages/contact-us"],
      ["Shipping & Returns", linkLookup.get("Shipping & Returns") || "/pages/shipping-and-returns"],
      ["FAQ", linkLookup.get("FAQ") || "/pages/faq"],
      ["Press Releases", linkLookup.get("Press Releases") || "/pages/press-releases"],
      ["International", linkLookup.get("International") || "/pages/international-distributors"],
      ["Site Map", linkLookup.get("Site Map") || "/pages/site-map"],
      ["Privacy Policy", linkLookup.get("Privacy Policy") || "/pages/privacy-policy"],
      ["Terms & Conditions", linkLookup.get("Terms & Conditions") || "/pages/terms-and-conditions"],
      [
        "Do not sell or share my Personal Information",
        linkLookup.get("Do not sell or share my Personal Information") || "/pages/data-sharing-opt-out",
      ],
    ];

    const primaryMenu = menus[0];
    const menuTitle = primaryMenu.querySelector(".tb-footer__menu-title");
    const list = primaryMenu.querySelector("ul");
    if (!list) {
      return;
    }

    menuTitle?.remove();
    list.innerHTML = desiredLinks
      .filter(([, href]) => Boolean(href))
      .map(
        ([text, href]) =>
          `<li><a href="${href.replace(/"/g, "&quot;")}">${text.replace(/&/g, "&amp;").replace(/</g, "&lt;")}</a></li>`,
      )
      .join("");

    menus.slice(1).forEach((menu) => menu.remove());
    footer.dataset.tbFooterNormalized = "true";
  }

  function initTheme() {
    initAnnouncementRotators();
    initDrawers();
    initCarousels();
    initMorePaymentOptionsScrubber();
    normalizeLegacyFooterMenus();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTheme, { once: true });
  } else {
    initTheme();
  }
})();
